module.exports = __webpack_public_path__ + "img/HZ-T1322.934cc498.jpg";